/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { markEnum } from "igniteui-react-core";
/**
 * Indicates the desired vertical alignment of the cell content.
 */
export var CellContentVerticalAlignment = /*@__PURE__*/ (function (CellContentVerticalAlignment) {
    /**
     * Align top.
     */
    CellContentVerticalAlignment[CellContentVerticalAlignment["Top"] = 0] = "Top";
    /**
     * Align center.
     */
    CellContentVerticalAlignment[CellContentVerticalAlignment["Center"] = 1] = "Center";
    /**
     * Align bottom.
     */
    CellContentVerticalAlignment[CellContentVerticalAlignment["Bottom"] = 2] = "Bottom";
    /**
     * Align stretch
     */
    CellContentVerticalAlignment[CellContentVerticalAlignment["Stretch"] = 3] = "Stretch";
    /**
     * Align auto
     */
    CellContentVerticalAlignment[CellContentVerticalAlignment["Auto"] = 4] = "Auto";
    return CellContentVerticalAlignment;
})({});
/**
 * @hidden
 */
export var CellContentVerticalAlignment_$type = /*@__PURE__*/ markEnum('CellContentVerticalAlignment', 'Top,0|Center,1|Bottom,2|Stretch,3|Auto,4');
//# sourceMappingURL=CellContentVerticalAlignment.js.map
